// @core/api/endpoints/fiscalization/get_shift_report.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetShiftReportResponse,
} from '../../../types/fiscalization';

const BASE_PATH = '/fiscalization';

/**
 * Get shift report
 * Returns the detailed report for a closed shift including receipt counts, totals, and VAT breakdown.
 */
export async function GetShiftReport(
  fiscalPointId: string,
  shiftId: string,
  options?: RequestOptions
): Promise<GetShiftReportResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-points/:fiscalPointId/shifts/:shiftId/report`;
  requestPath = requestPath.replace(':fiscalPointId', encodeURIComponent(fiscalPointId));
  requestPath = requestPath.replace(':shiftId', encodeURIComponent(shiftId));
  const requestOptions = options;
  return client.get<GetShiftReportResponse>(requestPath, { ...requestOptions });
}
